import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  data: [],
  maxDisplayedItems: 4,
  overflowIndex: 2
}, getTestId('BreadcrumbWidgetContainer'));